module.exports = __webpack_public_path__ + "static/Product_AppleTV-ffab4019b1c3575f975f20447cb12973.png";